export const mainProduct = {
  title: "Cenas Anti-Inflamatorias en 15 Minutos — Guía Maestra (PDF)",
  items: [
    "El Método de Digestión en Reposo",
    "Los 7 Pilares de la Cena",
    "El sistema del Plato 50-25-25",
    "Los 8 culpables ocultos",
    "Guía de especias carminativas",
    "Protocolo de Timing Digestivo",
  ],
};

export type BonusIcon = "recipes" | "cart" | "calendar" | "tea";

export const bonuses: { tag: string; icon: BonusIcon; title: string; description?: string; items: string[] }[] = [
  {
    tag: "B1",
    icon: "recipes",
    title: "Recetario Maestro 21 Cenas",
    description: "21 recetas organizadas en 4 categorías (Mar, Aves, Vegetales, Huevo). Máximo 15 minutos.",
    items: ["Lista de ingredientes exacta", "Pasos con tiempos reales", "Variante rápida de emergencia"],
  },
  {
    tag: "B2",
    icon: "cart",
    title: "Checklist de Despensa",
    description: "Tu mapa de compras definitivo para una cocina anti-inflamatoria.",
    items: ["Qué eliminar hoy mismo", "25 ingredientes básicos", "Guía de etiquetado en súper"],
  },
  {
    tag: "B3",
    icon: "calendar",
    title: "Planificador Semanal",
    items: ["Plantilla de 7 días imprimible", "Seguimiento de síntomas", "Escala de inflamación matutina"],
  },
  {
    tag: "B4+5",
    icon: "tea",
    title: "Infusiones & Ritual",
    items: ["5 infusiones post-cena eficaces", "Ritual de cierre de 30 min", "Respiración 4-7-8 anti-cortisol"],
  },
];

export type ReasonIcon = "clock" | "memory";

export const urgencyReasons: { icon: ReasonIcon; title: string; text: string }[] = [
  {
    icon: "clock",
    title: "Razón #1: Cada Noche Que Pasa Es Una Noche Perdida",
    text: "La inflamación crónica no toma días libres. Cada noche que cenás de la misma manera, acumulás un ciclo inflamatorio más. El mejor momento para empezar fue hace un año. El segundo mejor momento es esta noche.",
  },
  {
    icon: "memory",
    title: "Razón #2: Tu Cuerpo Tiene Memoria",
    text: "Cuanto más tiempo permanece el sistema inflamatorio activado, más tiempo tarda en regularse. Empezar hoy significa resultados esta semana. Esperar un mes significa empezar desde más atrás.",
  },
];
